import { DashboardFilterAction } from "../../actions/vendor/DashboardFilterAction";
import { VendorDashboarConstants } from "../../constants/AppConstants";

export interface DashboardFilter {
  pageNo: number;
  PageSize: number;
  RequestDate: string;
  RequestNo: string;
  RequestType: number;
  VendorType: string;
  VendorCategoryId: number;
  //IsUrgnet:boolean;
  IsUrgent: boolean;
  sAPVendorNo: string;
  vendorName: string;
  statusId: number|string;
}

const initialState = {
  pageNo: 1,
  PageSize: VendorDashboarConstants.TablerowCount,
  RequestDate: "",
  RequestNo: "",
  RequestType: 0,
  VendorType: "",
  VendorCategoryId: -1,
  sAPVendorNo: "",
  IsUrgent: false,
  vendorName: "",
  statusId: "",
};

export function VendorDashboradFilterReducer(
  state: DashboardFilter = initialState,
  action: DashboardFilterAction
): DashboardFilter {
  switch (action.type) {
    case "ON_CHANGE_VENDOR_FILTER_DATA":
      return {
        ...state,
        [action.payload[0]]: action.payload[1],
      };
      case "RESET_VENDOR_FILTER":
        return Object.assign(state, initialState);
    default:
      return state;
  }
}
